import { ReactElement } from 'react';

interface Props {
  imgSrc?: string;
}

/**
 * ダイアログに表示するグループアイコン。  
 * メンバーダイアログから戻った際にアイコンを再取得させないために GroupIconImage.tsx は利用しない。
 */
export default function GroupIcon({ imgSrc }: Props): ReactElement {
  return (
    <>
      {imgSrc ? <img src={imgSrc} alt="" style={style} /> : <span style={style}></span>}
    </>
  );
};

const style = {
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  objectFit: "cover" as const,
  marginRight: "8px"
}
